/**
 * Complete-the-set swap
 * =====================
 * Handles the cart-drawer band rendered by snippets/cart-complete-the-set.liquid.
 *
 * WHY THIS LIVES IN AN ASSET AND NOT INSIDE THE SNIPPET
 * -----------------------------------------------------
 * It started as an inline <script> in the snippet and worked exactly once.
 * The cart drawer re-renders by fetching `?section_id=cart-drawer`, parsing it
 * with DOMParser and swapping the nodes in — and <script> tags inserted that
 * way DO NOT EXECUTE. So the handler only ever bound on a full page load that
 * happened to render the band server-side. Empty the cart, add a bowl again,
 * and the button came back with nothing listening to it.
 *
 * Loading it as a real asset from sections/cart-drawer.liquid means it runs
 * once per page load regardless of cart state, and the delegated listener on
 * `document` survives every subsequent re-render.
 *
 * WHY TWO REQUESTS AND NOT ONE
 * -----------------------------
 * /cart/update.js changes quantities of lines already in the cart; it is not a
 * reliable way to introduce a variant that isn't there yet. So the bundle is
 * added first, then the single-bowl lines are zeroed. Order matters: if the
 * second call fails the customer holds both and can see it. The reverse order
 * would empty their cart and then fail to add anything, which they cannot
 * recover from. One re-render, after both calls settle.
 */
(function () {
  if (window.__ctsSwapBound) return;
  window.__ctsSwapBound = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function busy(btn, state) {
    if (state) {
      btn.setAttribute('aria-busy', 'true');
      btn.style.opacity = '0.6';
      btn.style.pointerEvents = 'none';
    } else {
      btn.removeAttribute('aria-busy');
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
    }
  }

  function rerenderDrawer() {
    return fetch(root() + 'cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var newDrawer = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('#CartDrawer');
        var container = document.querySelector('cart-drawer');
        if (newDrawer && container && typeof updateCartDrawer === 'function') {
          updateCartDrawer(container, newDrawer, true);
        } else {
          window.location.reload();
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cts-swap]');
    if (!btn) return;
    e.preventDefault();

    // Read state off the element at click time — the node may have been
    // replaced by a re-render since the last click.
    if (btn.getAttribute('aria-busy') === 'true') return;

    var addId = btn.getAttribute('data-add-variant');
    var keys = (btn.getAttribute('data-remove-keys') || '').split(',').filter(Boolean);
    if (!addId || !keys.length) {
      console.warn('[complete-the-set] missing swap data', { addId: addId, keys: keys });
      return;
    }

    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });

    busy(btn, true);

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(addId), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error('add failed ' + r.status + ': ' + t); });
        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error('remove failed ' + r.status + ': ' + t); });
        return rerenderDrawer();
      })
      .catch(function (err) {
        console.error('[complete-the-set] swap failed', err);
        window.location.reload();
      })
      .finally(function () {
        busy(btn, false);
      });
  });
})();
